const TOKEN_KEY = 'SMART_VISIT_ADMIN_TOKEN'
const USER_KEY = 'SMART_VISIT_ADMIN_USER'
const MENU_KEY = 'SMART_VISIT_ADMIN_MENUS'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) {
    return null
  }
  try {
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}))
}

export function removeUser() {
  localStorage.removeItem(USER_KEY)
}

export function getMenus() {
  const raw = localStorage.getItem(MENU_KEY)
  if (!raw) {
    return []
  }
  try {
    return JSON.parse(raw)
  } catch (e) {
    return []
  }
}

export function setMenus(menus) {
  localStorage.setItem(MENU_KEY, JSON.stringify(menus || []))
}

export function removeMenus() {
  localStorage.removeItem(MENU_KEY)
}
